import ajax from "../../../authenticationSafeAjax";
import { notificationWith }from "../portalModels";
import { timeHorizonToValidityPeriod } from "../../common/validityPeriodMigration";

export default (callback) => {
    ajax({
        headers: {
            "Accept": "application/json"
        },
        url: "/disclosure/api/portal"
    }, (statusCode, response) => {
        if (statusCode === 200) {
            const notifications = JSON.parse(response).notifications;
            notifications.map(notification => notification.presentations.map(timeHorizonToValidityPeriod));
            callback(notifications.map(notificationWith));
        }
    });
}


/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/portal/actions/fetchPortalData.js
 **/